import tb_logo from "../assets/tb_logo.jpg";
import dxc_logo from "../assets/dxc_logo.jpg";
import content from "../data/content.json";
import "./CareerSection.scss";
import "./HorizontalMenu.scss";
import HorizontalMenu from "../HorizontalMenu/HorizontalMenu";

const CareerSection = () => {
  return (
    <>
      <div className="about-me-wrapper container mt-5">
        <div className="row">
          <div className="col-12 col-md-4">
            <h2 className="about-me-title mb-0">About Me</h2>
          </div>
          <div className="col-12 col-md-8">
            <div className="about-me-desc-wrapper">
              <div className="about-me-desc">
                <p>{content.aboutMeDesc.partOne}</p>
                <p>{content.aboutMeDesc.partTwo}</p>
                <p>{content.aboutMeDesc.partThree}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="work-exp-section container mt-4 mb-4">
        <div className="row mb-3">
          <div className="col-12">
            <h2 className="work-exp-title mb-0">Work Experience</h2>
          </div>
        </div>

        <div className="org-item row mb-4">
          <div className="col-12 col-md-3 d-flex align-items-start justify-content-center mb-3 mb-md-0">
            <a href="https://tblocks.com/">
              <img
                className="org-logo img-fluid"
                alt="TechBlocks logo"
                src={tb_logo}
              />
            </a>
          </div>
          <div className="col-12 col-md-9">
            <div className="org-name-wrapper d-flex align-items-center flex-wrap">
              <h3 className="org-name mb-0">TechBlocks Consulting</h3>
              <span className="org-duration ms-2">(Oct 2023 - Present)</span>
            </div>
            <div className="org-role">Frontend Developer - Engineer</div>
            <p className="org-desc">{content.workExp.tbExp.tbIntro}</p>
            <ul>
              <li className="project-title">POC design & Skill Improvement</li>
              <li className="project-desc">
                Successfully completed the Microsoft Azure DevOps Engineer
                (AZ-400) certification, demonstrating proficiency in Azure
                DevOps processess using services like AzureBoards, Azure Repos,
                Azure Monitor, Azure CI/CD Pipelines and YAML templates for
                Azure Resource Management.
              </li>
              <li className="project-desc">
                Successfully completed the Microsoft Azure Developer Associate
                (AZ-204) certification, demonstrating proficiency in Azure cloud
                development, including VMs, Blob Storage, Functions, Cosmos DB,
                Entra ID, Key Vault, Logic Apps, Event Hubs, Service Bus, Azure
                Monitor.
              </li>
              <li className="project-desc">
                Creation of Azure resources (VMs & Blob Storage) as part of
                multiple POCs, strengthening the ability to deliver scalable,
                cloud-native solutions aligned with Microsoft Azure best
                practices.
              </li>
              <li className="project-desc">
                Skill development by self-paced learning of Node.js & Next.js
              </li>
              <br />
              <li className="project-title">Sample Project #2</li>
              <li className="project-desc">i did some work here</li>
              <br />
              <li className="project-title">Sample Project #3</li>
              <li className="project-desc">i did some work here</li>
            </ul>
          </div>
        </div>
        <div className="org-item row mb-4">
          <div className="col-12 col-md-3 d-flex align-items-start justify-content-center mb-3 mb-md-0">
            <a href="https://dxc.com/">
              <img
                className="org-logo img-fluid"
                alt="DXC logo"
                src={dxc_logo}
              />
            </a>
          </div>
          <div className="col-12 col-md-9">
            <div className="org-name-wrapper d-flex align-items-center flex-wrap">
              <h3 className="org-name mb-0">DXC Technology</h3>
              <span className="org-duration ms-2">(May 2021 - Sep 2023)</span>
            </div>
            <div className="org-role">
              Associate Professional Software Engineer
            </div>

            <p className="org-desc">
              From concept to commercialization, TechBlocks provides strategy,
              development and quality engineering services. From AI-powered
              cloud architectures to innovative digital products and experiences
              — we design, build, and scale the core digital platforms that
              power Fortune 100 enterprises and ambitious startups alike.
            </p>
            <ul>
              <li className="project-title">Sample Project #1</li>
              <li className="project-desc">i did some work here</li>
              <br />
              <li className="project-title">Sample Project #2</li>
              <li className="project-desc">i did some work here</li>
              <br />

              <li className="project-title">Sample Project #3</li>
              <li className="project-desc">i did some work here</li>
            </ul>
          </div>
        </div>
      </div>
      <div className="container wmf-wrapper mt-4">
        <div className="row">
          <div className="col-12">
            <div className="wmf-block">
              <div className="wmf-desc-wrapper">
                <span className="wmf-desc">This is a sample description</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="skills-bar py-4">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-12 col-lg-8">
              <div className="skills-block">
                <div className="skills-title">Skills</div>
                <HorizontalMenu
                  className="career-horizontal-menu"
                  items={content.skillSet}
                  variant="career"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CareerSection;
